import {
  service,
  model
} from 'eco-cli'
import {
  Share, File
} from '@/models/File.js'
const {
  disk, system
} = service;
const {
  Filter,
  Sort,
  Page
} = model;

// 打包文件夹
export const packFolderToZip = (id) => disk.withToken.get("/sftp/toZip/" + id)

// 下载记录统计/埋点
export const recordDownloadTimes = ({ client, dataId, userFigure }) => disk.withToken.post("/sftp/access/downAccess", {
  client, dataId, userFigure
})

// 是否达梦内部用户
export const isInnerUser = () => system.withToken.get("/system/user/hasInnerShareRole")

// 根据code获取文件列表
export const throughCodeObtainFileList = ({
    id,
    code
  }) =>
  disk.withToken.get('/sftp/link/getFile', {
    accessCode: code,
    linkId: id
  })

// 获取产品列表
export const getProducts = ({
    filter = Filter.new(),
    sort = Sort.new(),
    page = Page.new()
  }) =>
  disk.withToken.get('/sftp/link/getUserList', {
    ...filter.toServer(),
    ...sort.toServer(),
    ...page.toServer()
  }).then(res => {
    return {
      list: res.records.map((v) => Share.fromServer(v)),
      page: Page.fromServer(res)
    }
  })

// 获取部门分享列表
export const getShareList = ({
    filter = Filter.new(),
    sort = Sort.new(),
    page = Page.new()
  }) =>
  disk.withToken.get('/sftp/file/search/depart', {
    ...filter.toServer(),
    ...sort.toServer(),
    ...page.toServer()
  }).then(data => {
    return {
      list: data.records.map(item => File.fromServer(item)),
      page: Page.fromServer(data)
    }
  })

// 获取部门分享根目录
export const getRootFile = () => {
  return disk.withToken.get('/sftp/file/file/1', null).then(res => {
    return res
  })
}
